export default function Home() {
  return (
    <section
      id="home"
      className="d-flex flex-column align-items-center border-bottom"
    >
      <span className="d-block display-1 fw-bold text-light text-center mt-5">
        I am Hosni a React Developer
      </span>
      <img
        src="https://media.istockphoto.com/id/1209654046/vector/user-avatar-profile-icon-black-vector-illustration.jpg?s=612x612&w=0&k=20&c=EOYXACjtZmZQ5IsZ0UUp1iNmZ9q2xl1BD1VvN6tZ2UI="
        className="img-fluid rounded-circle h-25 w-25 my-5"
      ></img>
    </section>
  );
}
